import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    CartesianGrid,
} from "recharts";

export default function Profile() {
    const { user } = useAuth();
    const [results, setResults] = useState([]);
    const [stats, setStats] = useState(null);

    useEffect(() => {
        api.get("/results/me?limit=50").then((r) => setResults(r.data.reverse()));
        api.get("/stats/me").then((r) => setStats(r.data));
    }, []);

    const chartData = results.map((r, i) => ({
        idx: i + 1,
        wpm: Math.round(r.wpm),
        accuracy: Math.round(r.accuracy),
    }));

    return (
        <div className="max-w-5xl mx-auto px-6 py-10 space-y-8" data-testid="profile-container">
            <div className="glass rounded-2xl p-8">
                <p className="eyebrow">Profile</p>
                <h1 className="font-heading text-4xl font-semibold tracking-tight mt-2">{user?.name}</h1>
                <p className="text-[var(--lt-muted)] mt-1">{user?.email}</p>
                <div className="grid sm:grid-cols-4 gap-4 mt-6">
                    <Cell label="Total Tests" value={stats?.total_tests ?? 0} />
                    <Cell label="Best EN WPM" value={stats?.best_wpm_english ?? 0} />
                    <Cell label="Best NP WPM" value={stats?.best_wpm_nepali ?? 0} />
                    <Cell label="Avg Accuracy" value={`${stats?.avg_accuracy ?? 0}%`} />
                </div>
            </div>

            <div className="glass rounded-2xl p-6">
                <p className="eyebrow">Progress</p>
                <h3 className="font-heading text-2xl font-bold mt-1 mb-4">WPM Over Time</h3>
                {chartData.length > 0 ? (
                    <div style={{ width: "100%", height: 280 }}>
                        <ResponsiveContainer>
                            <LineChart data={chartData}>
                                <CartesianGrid stroke="#30363D" strokeDasharray="3 3" />
                                <XAxis dataKey="idx" stroke="#8B949E" />
                                <YAxis stroke="#8B949E" />
                                <Tooltip
                                    contentStyle={{
                                        background: "#161B22",
                                        border: "1px solid #30363D",
                                        borderRadius: 8,
                                    }}
                                />
                                <Line
                                    type="monotone"
                                    dataKey="wpm"
                                    stroke="#E06D53"
                                    strokeWidth={2}
                                    dot={{ fill: "#E06D53" }}
                                />
                                <Line
                                    type="monotone"
                                    dataKey="accuracy"
                                    stroke="#10B981"
                                    strokeWidth={2}
                                    dot={{ fill: "#10B981" }}
                                />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                ) : (
                    <p className="text-sm text-[var(--lt-muted)] text-center py-10">
                        Complete a run to see your chart.
                    </p>
                )}
            </div>
        </div>
    );
}

function Cell({ label, value }) {
    return (
        <div className="rounded-xl bg-[var(--lt-bg-2)] border border-[var(--lt-border)] p-4">
            <div className="eyebrow">{label}</div>
            <div className="font-mono-stat text-2xl mt-1">{value}</div>
        </div>
    );
}
